import axiosInstance from "./api";

// Create payment link
export const createPaymentLink = async (paymentData) => {
  try {
    const response = await axiosInstance.post(
      "/payments/create-order",
      paymentData,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update payment status
export const updatePaymentStatus = async (orderId, status = "SUCCESS") => {
  try {
    const response = await axiosInstance.post(`/payments/update-status`, null, {
      params: { order_id: orderId, status },
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data;
    }
    throw { success: false, message: error.message };
  }
};
